ceregoCommon.factory('V3InstructionalPresentationsResource', ['$resource', ($resource) ->
  $resource "", {},
    create:
      method: 'POST'
      isArray: false
      url: APIRoutes.v3_my_instructional_presentations_path()
])
